var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},_vm._l((_vm.powerList),function(item,index){return _c('div',{key:index,staticClass:"power"},[_c('img',{staticClass:"power_img",attrs:{"src":item.icon,"alt":""}}),_c('p',[_vm._v(_vm._s(item.desc))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }